module.exports = __webpack_public_path__ + "img/dosificacion_3.d1bc1a77.png";